export const pageScroll = {
  methods:{
    scrollToTheTop() {
      this.$nextTick(() => {
        const scrollableContainer = document.querySelector('html')
        scrollableContainer?.scrollTo(0, -scrollableContainer.scrollHeight)
      })
    },
  },
}